import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';

/**
 * Página 404 de la SPA.
 *
 * CloudFront no puede devolver un 404 real sin romper el enrutado de la SPA
 * (responde a los 404 de S3 con una página HTML y código 200), así que la señal
 * para los buscadores tiene que darla esta página: `noindex`. Sin ella,
 * cualquier URL inventada devolvía 200 con el contenido de la home, que Google
 * trata como "soft 404" o, peor, como duplicado indexable de la home.
 */
const NotFoundPage = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-white px-4">
    <SeoMeta
      title="Página no encontrada | BlueCMR"
      description="La página que buscas no existe o ha cambiado de dirección."
      noindex
    />
    <div className="max-w-xl text-center py-20">
      <p className="text-6xl font-bold text-blue-600 mb-4">404</p>
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Esta página no existe
      </h1>
      <p className="text-lg text-gray-600 mb-8">
        Puede que haya cambiado de dirección o que el enlace esté mal escrito.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link
          to="/"
          className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          Ir al inicio
        </Link>
        <Link
          to="/documentos/documento-control"
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
        >
          Documento de Control
        </Link>
        <Link
          to="/contacto"
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
        >
          Contacto
        </Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
